import CloseIcon from '@material-ui/icons/Close';
import {
    Box,
    Dialog,
    DialogContent,
    IconButton,
    Typography,
    useTheme
} from "@mui/material";
import { useState } from "react";
// import imagePlaceholder from '../../assets/img/image_placeholder.jpg';
import product1 from '../../assets/img/TestCreation/Test1.png';
import product3 from '../../assets/img/TestCreation/Test3.png';
import product4 from '../../assets/img/TestCreation/Test4.PNG';
import product5 from '../../assets/img/TestCreation/Test5.PNG';
import product6 from '../../assets/img/TestCreation/Test6.PNG';



const steps = [
    {
        title: "Step 1: Navigate to the Tests",
        description: [
            "From the Dashboard, click on the Tests tab.",
            "OR go to Manage Tests and select the Tests option.",
        ],
        image: product4,
    },
    {
        title: "Step 2: Start a New Test",
        description: [
            "On the Tests page, click the ‘+ New’ button to create a new exam test.",
        ],
        image: product3,
    },
    {
        title: "Step 3: Fill in Test Details",
        description: [
            "In the Information Tab, enter:",
            "Test Code",
            "Test Name",
            "Select Objective",
            "Target Audience",
        ],
        image: product5,
    },
    {
        title: "Step 4: Configure Test Settings",
        description: [
            "In the Configuration Tab, set up:",
            "Duration, Attempts Allowed, Questions/Page, Negative Points/Q, Points/Q.",
            "On/Off: Show Result, Navigation Allowed, Show Hint, Show Bookmark.",
        ],
        image: product6,
    },
    {
        title: "Step 5: Add Questions",
        description: [
            "In the Questions Tab >> Section ribbon, click the ‘Import’ button to upload questions.",
            "Choose your Subject/Chapter/Subtopic from Topic dropdown, then click the Search icon button.",
            "Select the questions from the list, click ‘Add Questions’, then save the test, review it, and publish.",
        ],
        image: product1,
    },
];

function TestCreationSteps() {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const handleImageClick = (imgSrc) => {
        setSelectedImage(imgSrc);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedImage(null);
    };
    return (
        <Box maxWidth="md" mx="auto" p={4}>
            <Typography variant="h5" gutterBottom>
                Creating a New Exam Test:
            </Typography>

            {steps.map((step, index) => (
                <Box
                    key={index}
                    display="flex"
                    flexDirection={index % 2 === 0 ? "row" : "row-reverse"}
                    alignItems="center"
                    my={5}
                    gap={4}
                    flexWrap="wrap"
                >
                    <Box
                        component="img"
                        src={step?.image}
                        alt={`Step ${index + 1}`}
                        onClick={() => handleImageClick(step.image)}
                        sx={{
                            width: { xs: "100%", sm: "25%" },
                            borderRadius: 2,
                            boxShadow: 3,
                            visibility: step.image ? 'visible' : 'hidden',
                            cursor: "pointer",
                            transition: "transform 0.2s",
                            "&:hover": {
                                transform: "scale(1.05)",
                            },
                        }}
                    />
                    <Box flex="1" minWidth="250px">
                        {step?.mainTitle && <Typography variant="h6" sx={{ color: '#e63573', textTransform: 'none' }}>{step.mainTitle}</Typography>}
                        <Typography variant="body1" sx={{ textTransform: 'none', fontWeight: 'bold' }}>{step.title}</Typography>
                        <ul>
                            {step.description.map((item, idx) => (
                                <li key={idx}>
                                    <Typography variant="body1">{item}</Typography>
                                </li>
                            ))}
                        </ul>
                    </Box>
                </Box>
            ))}
            {/* Dialog for Image Popup */}
            <Dialog open={open} onClose={handleClose} maxWidth="md">
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        zIndex: 1,
                        color: "grey.500",
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    {selectedImage && (
                        <Box
                            component="img"
                            src={selectedImage}
                            alt="Popup Preview"
                            sx={{
                                width: "100%",
                                height: "auto",
                                borderRadius: 2,
                                boxShadow: 3,
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </Box>
    );
}

export default TestCreationSteps;
